export const emptyObject = (): any => {
    return Object.freeze({});
};
